import React, { useContext } from "react";
import { RicosContext } from "./../../ricos-context";
import { EditIcon, ToggleButton } from "./../../toolbars-ui";
const ImageEditorButton = ({ toolbarItem, dataHook }) => {
  const { t } = useContext(RicosContext) || {};
  const onClick = toolbarItem.commands.click;
  const node = toolbarItem.attributes.selectedNode;
  const src = node?.attrs.image?.src?.id;
  return /* @__PURE__ */ React.createElement(
    ToggleButton,
    {
      Icon: EditIcon,
      onClick: () => onClick({ src }),
      dataHook,
      tooltip: t("ImageEditorButton_Tooltip"),
      disabled: !src
    }
  );
};
var ImageEditorButton_default = ImageEditorButton;
export {
  ImageEditorButton_default as default
};
//# sourceMappingURL=ImageEditorButton.js.map
